import { render, staticRenderFns } from "./UpdateAppointment.vue?vue&type=template&id=bb7263d0&scoped=true"
import script from "./UpdateAppointment.vue?vue&type=script&lang=js"
export * from "./UpdateAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7263d0",
  null
  
)

export default component.exports